import { GLOBAL_WEB_COMPONENT_CACHE } from '@shared/constants/global'

export function putInCache(cacheName: string, value: string, clearable: boolean = true) {
  window[GLOBAL_WEB_COMPONENT_CACHE] = window[GLOBAL_WEB_COMPONENT_CACHE] || {}
  window[GLOBAL_WEB_COMPONENT_CACHE][cacheName] = {
    ...window[GLOBAL_WEB_COMPONENT_CACHE][cacheName],
    data: value,
    clearable,
    usedAt: Date.now(),
  }
  setTimeout(cleanupCache, 0)
}

export function getFromCache(cacheName: string): string | undefined {
  window[GLOBAL_WEB_COMPONENT_CACHE] = window[GLOBAL_WEB_COMPONENT_CACHE] || {}
  const cached = window[GLOBAL_WEB_COMPONENT_CACHE][cacheName]
  if (cached && cached.data) {
    cached.usedAt = Date.now()
    return cached.data
  }
  setTimeout(cleanupCache, 0)
  return undefined
}

export function cleanupCache() {
  window[GLOBAL_WEB_COMPONENT_CACHE] = window[GLOBAL_WEB_COMPONENT_CACHE] || {}
  const now = Date.now()
  for (const key in window[GLOBAL_WEB_COMPONENT_CACHE]) {
    const cached = window[GLOBAL_WEB_COMPONENT_CACHE][key]
    if (cached.clearable && now - cached.usedAt > 1000 * 60 * 60) { // Clear after 1 hour
      delete window[GLOBAL_WEB_COMPONENT_CACHE][key]
    }
  }
}
